import React, { useEffect, useMemo, useState } from 'react';
import { useTenantContext } from '../../context/TenantContext';
import { PublicHeader } from '../layout/PublicHeader';

// Chargement dynamique des templates d'en-tête
const headerModules = import.meta.glob('/src/templates/headers/**/*.{tsx,jsx,ts,js}');

export const HeaderSlot: React.FC = () => {
  const { tenant } = useTenantContext();

  const selectedPath = useMemo(() => {
    const templates = (tenant?.config?.templates || {}) as any;
    const headers = (templates.headers || {}) as Record<string, string>;
    return headers.default || '';
  }, [tenant]);

  const [HeaderComponent, setHeaderComponent] = useState<React.ComponentType | null>(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [tenantLoading, setTenantLoading] = useState(!tenant);

  // Suivre le chargement du tenant
  useEffect(() => {
    setTenantLoading(!tenant);
  }, [tenant]);

  useEffect(() => {
    let mounted = true;
    if (selectedPath && headerModules[selectedPath]) {
      setLoadingTemplate(true);
      const loader = headerModules[selectedPath] as () => Promise<{ default: React.ComponentType }>;
      loader()
        .then((mod) => {
          if (mounted) setHeaderComponent(() => mod.default);
        })
        .catch((err) => {
          console.error('Erreur de chargement du header template:', err);
          if (mounted) setHeaderComponent(null);
        })
        .finally(() => mounted && setLoadingTemplate(false));
    } else {
      setHeaderComponent(null);
      setLoadingTemplate(false);
    }
    return () => {
      mounted = false;
    };
  }, [selectedPath]);

  // Pendant le chargement du tenant ou du template, ne rien afficher (éviter le flash)
  if (tenantLoading || loadingTemplate) return null;
  if (HeaderComponent) return <HeaderComponent />;
  return <PublicHeader />;
};
